import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import { BrandColors } from '../../global/helpers-marketing';
import { insertElements } from '../../global/render-api';
import type { UIRemarkLayouts } from './ui-remark.type';
import { validateRemarkColor } from './ui-remark.helpers';
import styles from './ui-remark.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIRemark
 * @element ui-remark
 * @classdesc Represents a class for <code>ui-remark</code> element.
 * Formerly known as eye-catcher.
 * @property {UIRemarkLayout} [layout="speech"] {@attr layout} Shape of the remark.
 * @property {UIBrandColor} [color="lilac"] {@attr color} Color of the remark.
 * @example
 * <ui-remark layout="speech">Great offer!</ui-remark>
 */
@Component({ tag: 'ui-remark', styles })
export class UIRemark extends UIElement {
    /**
     * @type {UIRemarkLayouts}
     */
    static readonly Layout: UIRemarkLayouts = {
        Circle: 'circle',
        Speech: 'speech',
        SpeechSquare: 'speech-square',
    } as const;

    @Attribute(String) layout: string = UIRemark.Layout.Circle;
    @Attribute({
        type: String,
        default: BrandColors.Lilac,
        validate: validateRemarkColor,
    })
    color: string = BrandColors.Lilac;

    /**
     * @inheritDoc
     */
    override render(): void {
        insertElements(this, [
            {
                tagName: 'div',
                attributes: {
                    class: 'ui-remark__content',
                },
                children: this.childNodes,
            },
        ]);
    }
}
